
export const Width = {
  WIDE: "1600px",
  NORMAL: "950px"
}